export const fallbackLng = 'en';
export const languages = [fallbackLng, 'es'];

export const cookieName = 'i18next';
export const defaultNS = 'translation';
export const defaultLocale = 'en';
export const locales = ['en', 'es'];

interface i18nOptions {
  supportedLngs: string[];
  fallbackLng: string;
  lng: string;
  fallbackNS: string;
  defaultNS: string;
  ns: string;
}

export const getOptions = (lng = fallbackLng, ns = defaultNS): i18nOptions => ({
  supportedLngs: languages,
  fallbackLng,
  lng,
  fallbackNS: defaultNS,
  defaultNS,
  ns,
});
